import React from "react";
import { ExternalLink } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

const DivisionsPage = () => {
  return (
    <div>
      <SEO
        title="Groundhogs™ Divisions | Thunder Bay"
        description="Explore Groundhogs™ divisions and brands serving Thunder Bay and Northwestern Ontario."
        canonicalPath="/divisions"
      />
      <Header />

      {/* Hero Section */}
      <section className="gh-intro pt-32 pb-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-12" style={{ color: "var(--dark-navy)" }}>
            Groundhogs™ – Proven Systems Under One Brand
          </h1>

          {/* Our Divisions Section */}
          <div className="mb-16">
            <h2 className="text-4xl font-bold mb-8" style={{ color: "var(--dark-navy)" }}>
              Our Divisions
            </h2>
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-lg shadow-md border-l-4" style={{ borderColor: "var(--primary-orange)" }}>
                <h3 className="text-2xl font-bold mb-3" style={{ color: "var(--dark-navy)" }}>
                  Groundhogs™ Foundations
                </h3>
                <p className="text-lg mb-4" style={{ color: "var(--text-dark)" }}>
                  Expert foundation repair and new construction.
                </p>
                <a 
                  href="https://groundhogs.ca" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 font-semibold hover:opacity-70"
                  style={{ color: "var(--primary-orange)" }}
                >
                  <span>Learn more</span>
                  <ExternalLink size={18} />
                </a>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md border-l-4" style={{ borderColor: "var(--primary-orange)" }}>
                <h3 className="text-2xl font-bold mb-3" style={{ color: "var(--dark-navy)" }}>
                  Groundhogs™ Septics
                </h3>
                <p className="text-lg mb-4" style={{ color: "var(--text-dark)" }}>
                  Full-service septic system installation and repair.
                </p>
                <a 
                  href="https://groundhogsseptics.com" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 font-semibold hover:opacity-70"
                  style={{ color: "var(--primary-orange)" }}
                >
                  <span>Visit GroundhogsSeptics.com</span>
                  <ExternalLink size={18} />
                </a>
              </div>
            </div>
          </div>

          {/* Licensed Operators Section */}
          <div className="mb-16">
            <h2 className="text-4xl font-bold mb-6" style={{ color: "var(--dark-navy)" }}>
              Licensed Operators
            </h2>
            <div className="bg-gray-50 p-8 rounded-lg">
              <p className="text-lg mb-4" style={{ color: "var(--text-dark)" }}>
                Expansion-minded contractors: Inquire about licensing the Groundhogs™ brand, systems, and SOPs in your territory.
              </p>
              <p className="text-lg" style={{ color: "var(--text-dark)" }}>
                <strong>Email:</strong>{" "}
                <a 
                  href="mailto:hello@groundhogs.ca"
                  className="font-semibold hover:opacity-70"
                  style={{ color: "var(--primary-orange)" }}
                >
                  hello@groundhogs.ca
                </a>
              </p>
            </div>
          </div>

          <hr className="border-gray-300 mb-8" />

          {/* Trademark Notice */}
          <p className="text-center" style={{ fontSize: "0.9em", color: "#666" }}>
            Groundhogs™ (Trademark Pending – CIPO #2435119)
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DivisionsPage;
